/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Hitl_CheckpointsInputs */

const en_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HITL checkpoints`)
};

const ar_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشاركة بشرية في الحلقة`)
};

const bn_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HITL চেকপয়েন্ট`)
};

const de_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HITL-Kontrollpunkte`)
};

const es_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`puntos de control HITL`)
};

const fr_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Points de contrôle HITL`)
};

const pt_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pontos de verificação HITL`)
};

const zh_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HITL 检查点`)
};

const tr_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HITL kontrol noktaları`)
};

const ru_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контрольно-пропускные пункты HITL`)
};

const pl_svchip_hitl_checkpoints = /** @type {(inputs: Svchip_Hitl_CheckpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punkty kontrolne HITL`)
};

/**
* | output |
* | --- |
* | "HITL checkpoints" |
*
* @param {Svchip_Hitl_CheckpointsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_hitl_checkpoints = /** @type {((inputs?: Svchip_Hitl_CheckpointsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Hitl_CheckpointsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_hitl_checkpoints(inputs)
	if (locale === "bn") return bn_svchip_hitl_checkpoints(inputs)
	if (locale === "de") return de_svchip_hitl_checkpoints(inputs)
	if (locale === "es") return es_svchip_hitl_checkpoints(inputs)
	if (locale === "fr") return fr_svchip_hitl_checkpoints(inputs)
	if (locale === "pt") return pt_svchip_hitl_checkpoints(inputs)
	if (locale === "zh") return zh_svchip_hitl_checkpoints(inputs)
	if (locale === "tr") return tr_svchip_hitl_checkpoints(inputs)
	if (locale === "ru") return ru_svchip_hitl_checkpoints(inputs)
	if (locale === "pl") return pl_svchip_hitl_checkpoints(inputs)
	return en_svchip_hitl_checkpoints(inputs)
});